import DownArrowIcon from 'components/icon/down-arrow-icon';
import styles from './style.module.scss';
import { PropsWithTestId } from 'types';
import { contentPageIds } from 'constants/test-constants';

/**
 * The props for the ContentPageHeroSlide component.
 *
 * @param testId The test ID for the component. Default is {@link contentPageIds.heroSlide}.
 */
export type ContentPageHeroSlideProps = PropsWithTestId<{
  backgroundImageSrc: string;
  downArrowRef: React.RefObject<HTMLDivElement>;
  topText: string;
  bottomText: string;
}>;

export default function ContentPageHeroSlide({ backgroundImageSrc, downArrowRef, topText, bottomText, testId = contentPageIds.heroSlide }: ContentPageHeroSlideProps) {
  const onArrowClick = () => {
    if (downArrowRef.current) {
      downArrowRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className={styles.component} style={{ backgroundImage: `url("${backgroundImageSrc}")` }} data-testid={testId}>
      <div>
        <h2 className={styles['top-text']}>{topText}</h2>
        <div className={styles['bottom-section']}>
          <a>
            <DownArrowIcon className={styles['down-arrow']} onClick={onArrowClick}/>
          </a>
          <h2 className={styles['bottom-text']}>{bottomText}</h2>
        </div>
      </div>
    </div>
  );
}
